import { render } from "./property-commutenew.vue?vue&type=template&id=5aeeb308"
import script from "./property-commutenew.js?vue&type=script&lang=js"
export * from "./property-commutenew.js?vue&type=script&lang=js"

import "./property-commutenew.vue?vue&type=style&index=0&id=5aeeb308&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__